<template>
  <div>
    <div class="navTitle">
      <div class="nav_warp">
        <div style="padding:0 20px 0 0px;width:100px">{{dataObjs.lishishuju}}</div>
        <div style="padding:0 20px 0 0px"><el-button type="success" size="mini" @click="myFileupData" >{{dataObjs.daochu}}</el-button></div>
         <div class="times">
                 <div style="width:55%">
                    <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    :range-separator="$t('reach')"
                    format="yyyy/MM/dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>

                 </div>
                   <div class="dayTime">
                  <el-radio-group v-model="tabPosition" @change="dayTime">
                    <el-radio-button label="1hour">{{dataObjs.xiaoshi1}}</el-radio-button>
                    <el-radio-button label="2hour">{{dataObjs.xiaoshi2}}</el-radio-button>
                    <el-radio-button label="1day">{{dataObjs.tian1}}</el-radio-button>
                    <el-radio-button label="1week">{{dataObjs.zhou1}}</el-radio-button>
                    <el-radio-button label="1month">{{dataObjs.yue1}}</el-radio-button>
                  </el-radio-group>
                   <el-button size="mini" type="primary" style="height:27px !important;margin-bottom:2px; margin-left:10px; padding:0 20px !important" @click="shuaxinClick">{{dataObjs.shuaxin}}</el-button>
                </div>
                  <div style="padding:0 10px">
                 <el-button size="mini" type="danger" style="heigth:27px; !important" @click="epmoreAll" v-if="roletype == 0">{{dataObjs.qingkonglishishuju}}</el-button>
              
              </div>
                </div>
      </div>
    </div>
    <el-table :data="channelidList" border style="width: 100%" :row-class-name="tableRowClassName" max-height="700"  :header-cell-style="{background:'#eef1f6',color:'#606266'}">
      <el-table-column prop="collecttime"  :label="dataObjs.riqi"></el-table-column>
      <el-table-column
        v-for="(item,index) in cheidFengxiang"
        :prop="conetnCunt[index]"
           :label="item.channelname== ''?lang_file == 'zh-cn'?item.unittype:item.unittype_en:item.channelname "
        :key="item.channelid"
      ></el-table-column>
    </el-table>
 <dataPheader :page-data="pageData" :total="total"  :get-table-list="tableList"></dataPheader>
    <div style="display:none">  {{hadnTimes}}</div>
  </div>
</template>

<script>
import dataPheader from '@/components/common/dataPheader'
import {lang_fend} from '@/network/index'
export default {
  components:{
    dataPheader
  },
  props: {
     pageData:{
      type:Object,
      default:{}
    },
      dateset: {
      type: String,
      default: "",
    },
    tableList:{
      type:Function,
      default:Function
    },
       total:{
      type:Number,
      default:1
    },
    channelidList: {
      type: Array,
      default: []
    },
      value1: {
      type: Array,
      default: [],
    },
    cheidFengxiang: {
      type: Array,
      default: []
    },
    conetnCunt: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    pickerOptions: {},
      // value1:'',
      tabPosition: '',
      lang_file: "",
      channelidListFly: true,
       roletype: sessionStorage.getItem("roletypeValue"),
      dataObjs:{}
    };
  },
  computed:{
    // 获取点击的时间
    hadnTimes(){
      return this.tabPosition = this.dateset
      
    }
  },
  created() {},
  mounted() {
    this.lang_file = sessionStorage.getItem("lang_file");
    this.lang_fend()
  },
  methods: {
        // 刷新
    shuaxinClick(){
      this.$emit('setClick')
    },
        epmoreAll(){
      this.$emit('mantClick')
    },
    dayTime(e){
      console.log(e);
      
     this.$emit("dayTime", e);
      
    },
    confingClick(){
         this.$emit("confingClick", this.value1);
    },
      async lang_fend(){
      let page = 'realtimedata_detail_page'
      let objs = {
        page,
        lang_file:this.lang_file,
      }
      const {data,code} = await lang_fend(objs)
      console.log(data);
      
      this.dataObjs = data
      // this.xiaoshi = data.1xiaoshi
  },
    // 下载
      myFileupData() {
      this.$emit("myFileupData");
    },
    // 斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    }
  }
};
</script>

<style scoped >
.navTitle{
   width: 100%;
  background: #5cb6d9;
  height: 37px;
  line-height: 37px;
  color: #ffffff;
  padding: 0 20px;
  display: flex;
}
.nav_warp{
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.dayTime{
  width: 100%;
  padding: 0 20px;
}
.times{
  width: 100%;
  display: flex;
}
</style>
